import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

/** Shown for any URL the site doesn't have. */
export default function NotFound() {
  const { t } = useTranslation();
  return (
    <div className="not-found-page">
      <h1>{t('notFound.title')}</h1>
      <p>{t('notFound.body')}</p>
      <Link to="/" className="signup-link">{t('notFound.home')}</Link>
      <style>{`
        .not-found-page {
          max-width: 640px;
          margin: 80px auto;
          padding: 0 16px;
          text-align: center;
        }
        .not-found-page h1 { font-size: 32px; margin-bottom: 12px; }
        .not-found-page p { color: #555; margin-bottom: 32px; }
        .not-found-page .signup-link { display: inline-block; }
      `}</style>
    </div>
  );
}
